import { instanceReadStatistics } from 'client/redux/instance/actionCreators';
import { INSTANCE_MWTD_READ_STATISTICS } from 'client/redux/mwtd/constants';

export const instanceMwtdReadStatistics = (id, statistic, query) => dispatch => {
  switch (statistic) {
    default: return dispatch(instanceReadStatistics(INSTANCE_MWTD_READ_STATISTICS, id, statistic, query));
  }
};
